/**
 * label: string
 * icon: svg
 * href: https || /path || 'function'
 * calloutClass: 'rainbow' || className => background rainbow and custom css
 * initialOpenState: true || false
 * items: array sample parent
 * att: attach => text || icon.png
 */

export const menuItems = [
  {
    label: 'Khám phá',
    icon: 'explore.svg',
    href: '',
    actives: ['/explore'],
    items: [
      {
        label: 'Digital NFT Marketplace',
        icon: 'digital-nft.svg',
        iconLight: 'digital-nft-light.svg',
        href: '/marketplace',
        actives: [''],
      },
      // {
      //   label: 'Physical NFT Marketplace',
      //   icon: 'Physical-NFT.svg',
      //   iconLight: 'Physical-NFT.svg',
      //   href: '',
      //   actives: [''],
      // },
      // {
      //   label: 'Joint Investment',
      //   icon: 'Joint-Investment.svg',
      //   iconLight: 'Joint-Investment.svg',
      //   href: '',
      //   actives: [''],
      // },
      // {
      //   label: 'Drops',
      //   icon: 'Drops.svg',
      //   iconLight: 'Drops.svg',
      //   href: '',
      //   actives: [''],
      // },
      // {
      //   label: 'Learn And Earn',
      //   icon: 'learn-and-earn.svg',
      //   iconLight: 'learn-and-earn-light.svg',
      //   href: 'https://testnet.asdiearn.io',
      //   actives: ['https://testnet.asdiearn.io'],
      // },
    ],
  },
  {
    label: 'Tạo',
    icon: 'create.svg',
    href: '',
    actives: ['/create'],
    items: [
      {
        label: 'Create Collection',
        icon: 'copy-2.svg',
        iconLight: 'copy-2-light.svg',
        href: '/create/collection',
        actives: ['/collection'],
      },
      {
        label: 'Create NFT',
        icon: 'create-nft.svg',
        iconLight: 'create-nft-light.svg',
        href: '/create/nft',
        actives: ['/nft'],
      },
    ],
  },
]

export default menuItems
